<div class="container-fluid account-information-wrapper">
  <div class="profile-wrapper">
    <cdk-accordion class="example-accordion">
      <cdk-accordion-item
        *ngIf="accountSettingForm"
        #accordionItem1="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-1'"
        [attr.aria-expanded]="accordionItem1.expanded"
        [attr.aria-controls]="'accordion-body-1'">
        <div
          class="example-accordion-item-header"
          [ngClass]="{ 'header-gray': accordionItem1.expanded }"
          (click)="accordionItem1.toggle()">
          <span class="example-accordion-item-description">
            <mat-icon>
              {{ accordionItem1.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
          Account Settings
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItem1.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-1'"
          [attr.aria-labelledby]="'accordion-header-1'">
          <form
            [formGroup]="accountSettingForm"
            (submit)="onSubmitAccountSettings($event)"
            example-form
            class="example-form">
            <div *ngIf="user$ | async as user">
              <!-- First Section: Zone Details -->
              <mat-grid-list cols="3" rowHeight="auto">
                <!-- Zone Details Header -->
                <mat-grid-tile [colspan]="3">
                  <h6 class="h5-tile mb-3">Your Profile</h6>
                </mat-grid-tile>
                <div class="row">
                  <app-text-input
                    class="col-12 col-lg-6"
                    [parentForm]="accountSettingForm"
                    controlName="name"
                    [value]="user.name"
                    placeholder="Enter Name">
                  </app-text-input>
                  <app-text-input
                    class="col-12 col-lg-6"
                    [parentForm]="accountSettingForm"
                    controlName="email"
                    placeholder="Enter Email">
                  </app-text-input>
                  <app-text-input
                    class="col-12"
                    [ngClass]="
                      !accountSettingForm.controls['phoneNumber'].invalid &&
                      !accountSettingForm.controls['isPhoneValidated'].value
                        ? 'col-md-4'
                        : 'col-md-6'
                    "
                    [parentForm]="accountSettingForm"
                    controlName="phoneNumber"
                    type="tel"
                    placeholder="Enter Phone Number"
                    hint="e.g., +15556661234"
                    showErrors
                    required>
                  </app-text-input>
                  <div
                    class="col-12"
                    [ngClass]="
                      !accountSettingForm.controls['phoneNumber'].invalid &&
                      !accountSettingForm.controls['isPhoneValidated'].value
                        ? 'col-md-2'
                        : ''
                    "
                    *ngIf="
                      !accountSettingForm.controls['phoneNumber'].invalid &&
                      !accountSettingForm.controls['isPhoneValidated'].value
                    ">
                    <button
                      mat-flat-button
                      color="primary"
                      type="button"
                      (click)="validatePhoneNumber()"
                      class="validatePhoneBtn"
                      style="width: 100%"
                      [disabled]="
                        accountSettingForm.controls['phoneNumber'].invalid
                      ">
                      Validate
                    </button>
                  </div>

                  <div
                    class="col-12 col-md-6"
                    *ngIf="isPhoneValidationSent$ | async">
                    <div
                      class="row"
                      *ngIf="
                        !accountSettingForm.controls['isPhoneValidated'].value
                      ">
                      <app-text-input
                        class="col col-md-8"
                        [parentForm]="accountSettingForm"
                        controlName="otp"
                        type="number"
                        placeholder="Enter Verification code"
                        required
                        showErrors>
                      </app-text-input>

                      <div class="col col-md-4">
                        <button
                          mat-flat-button
                          color="primary"
                          style="width: 100%"
                          type="button"
                          [disabled]="
                            accountSettingForm.controls['otp'].invalid
                          "
                          (click)="verifyOTP()">
                          Verify OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row mat-error mt-2"
                  *ngIf="twilioError$ | async as twilioError">
                  <small class="col-12">
                    {{ twilioError }}
                  </small>
                </div>
              </mat-grid-list>
              <div class="button-container">
                <button mat-raised-button color="primary" type="submit">
                  <mat-icon
                    class="small-icon"
                    aria-hidden="false"
                    aria-label="Save icon"
                    aria-setsize="10"
                    fontIcon="save"></mat-icon>
                  Save
                </button>
              </div>
            </div>
            <div *ngIf="corporateAccount$ | async as corporateAccount">
              <mat-grid-list cols="3" rowHeight="auto">
                <!-- Zone Details Header -->
                <mat-grid-tile [colspan]="3">
                  <h6 class="h5-tile">Company Profile</h6>
                </mat-grid-tile>

                <!-- State Input -->
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>NAME*</mat-label>
                  <input
                    matInput
                    placeholder="Enter Name"
                    value="{{ corporateAccount.name }}"
                    readonly />
                </mat-form-field>
                <!-- Zip Code Input -->
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Phone*</mat-label>
                  <input
                    matInput
                    placeholder="Enter Phone"
                    value="{{ corporateAccount.phoneNumber | phone }}"
                    readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Fax*</mat-label>
                  <input
                    matInput
                    placeholder="Enter Fax"
                    value="{{ corporateAccount.faxNumber | phone }}"
                    readonly />
                </mat-form-field>
              </mat-grid-list>
            </div>
          </form>
        </div>
      </cdk-accordion-item>
      <cdk-accordion-item
        #accordionItem2="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="1"
        [attr.id]="'accordion-header-2'"
        [attr.aria-expanded]="accordionItem2.expanded"
        [attr.aria-controls]="'accordion-body-2'">
        <div
          class="example-accordion-item-header"
          [ngClass]="{ 'header-gray': accordionItem2.expanded }"
          (click)="accordionItem2.toggle()">
          <span class="example-accordion-item-description">
            <mat-icon>
              {{ accordionItem2.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
          Notification Settings
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItem2.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-2'"
          [attr.aria-labelledby]="'accordion-header-2'">
          <div class="notification-settings" example-form class="example-form">
            <form
              [formGroup]="notificationSettingForm"
              example-form
              class="example-form">
              <div class="notification-group">
                <div class="notification-text">
                  <h6 class="h5-tile">Case Updates</h6>
                  <p>
                    These notifications are for customer service replies on any
                    open case and resolution updates.
                  </p>
                </div>
                <div class="notification-settings">
                  <mat-slide-toggle
                    formControlName="email"
                    (change)="onSubmitNotificationSettings()">
                    Email
                  </mat-slide-toggle>
                  <mat-slide-toggle
                    formControlName="sms"
                    [disabled]="!this.user.isPhoneValidated"
                    [matTooltip]="
                      !this.user.isPhoneValidated
                        ? 'Validate Phone Number In Account Settings To Enable'
                        : undefined
                    "
                    matTooltipPosition="right"
                    (change)="onSubmitNotificationSettings()">
                    SMS
                  </mat-slide-toggle>
                </div>
              </div>
            </form>
          </div>
        </div>
      </cdk-accordion-item>
      <cdk-accordion-item
        #accordionItem3="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="1"
        [attr.id]="'accordion-header-3'"
        [attr.aria-expanded]="accordionItem3.expanded"
        [attr.aria-controls]="'accordion-body-3'">
        <div
          class="example-accordion-item-header"
          [ngClass]="{ 'header-gray': accordionItem3.expanded }"
          (click)="accordionItem3.toggle()">
          <span class="example-accordion-item-description">
            <mat-icon>
              {{ accordionItem3.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
          What's New
        </div>
        <div
          *ngIf="whatsNew$ | async as whatsNew"
          class="example-accordion-item-body example-form"
          role="region"
          [style.display]="accordionItem3.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-3'"
          [attr.aria-labelledby]="'accordion-header-3'">
          <div [innerHtml]="whatsNew.content"></div>
        </div>
      </cdk-accordion-item>
      <cdk-accordion-item
        #accordionItem4="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="1"
        [attr.id]="'accordion-header-4'"
        [attr.aria-expanded]="accordionItem4.expanded"
        [attr.aria-controls]="'accordion-body-4'">
        <div
          *ngIf="termsAndConditions$ | async as termsAndConditions"
          class="example-accordion-item-header"
          [ngClass]="{ 'header-gray': accordionItem4.expanded }"
          (click)="accordionItem4.toggle()">
          <span class="example-accordion-item-description">
            <mat-icon>
              {{ accordionItem4.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
          Terms & Conditions
        </div>
        <div
          *ngIf="termsAndConditions$ | async as termsAndConditions"
          class="example-accordion-item-body example-form"
          role="region"
          [style.display]="accordionItem4.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-4'"
          [attr.aria-labelledby]="'accordion-header-4'">
          <div>
            <h3>{{ termsAndConditions.title }}</h3>
          </div>
          <div>
            <p>
              Last Modified :
              {{
                (termsAndConditions$ | async)?.updatedDate
                  | date: 'MMMM d, yyyy'
              }}
            </p>
          </div>
          <div [innerHtml]="termsAndConditions.content"></div>
        </div>
      </cdk-accordion-item>
      <cdk-accordion-item
        #accordionItem5="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="1"
        [attr.id]="'accordion-header-5'"
        [attr.aria-expanded]="accordionItem5.expanded"
        [attr.aria-controls]="'accordion-body-5'">
        <div
          *ngIf="privacyPolicy$ | async as privacyPolicy"
          class="example-accordion-item-header"
          [ngClass]="{ 'header-gray': accordionItem5.expanded }"
          (click)="accordionItem5.toggle()">
          <span class="example-accordion-item-description">
            <mat-icon>
              {{ accordionItem5.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
          Privacy Policy
        </div>
        <div
          *ngIf="privacyPolicy$ | async as privacyPolicy"
          class="example-accordion-item-body example-form"
          role="region"
          [style.display]="accordionItem5.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-5'"
          [attr.aria-labelledby]="'accordion-header-5'">
          <div>
            <h3>{{ privacyPolicy.title }}</h3>
          </div>
          <div>
            <p>
              Last Modified :
              {{ (privacyPolicy$ | async)?.updatedDate | date: 'MMMM d, yyyy' }}
            </p>
          </div>
          <div [innerHtml]="privacyPolicy.content"></div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
</div>
<!-- <div class="row">
  <div class="col-10 offset-1 profile-wrapper">
    <div class="row">
      <div class="col-12 profile-title">Documents</div>
    </div>

    <ng-container *ngIf="termsAndConditions$ | async as termsAndConditions">
      <app-collapsible-section
        [contentId]="'termsAndConditions'"
        [buttonTitle]="'Terms And Conditions'"
        [content]="termsAndConditions.content"
        [title]="termsAndConditions.title"
        [date]="termsAndConditions.updatedDate">
      </app-collapsible-section>
    </ng-container>

    <ng-container *ngIf="privacyPolicy$ | async as privacyPolicy">
      <app-collapsible-section
        [contentId]="'privacyPolicy'"
        [buttonTitle]="'Privacy Policy'"
        [content]="privacyPolicy.content"
        [title]="privacyPolicy.title"
        [date]="privacyPolicy.updatedDate">
      </app-collapsible-section>
    </ng-container>
  </div>
</div> -->
